import { render, staticRenderFns } from "./gift-box.vue?vue&type=template&id=923f9ce6"
import script from "./gift-box.vue?vue&type=script&lang=js"
export * from "./gift-box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports